import {
  MULTI_SELECT_FS_OBJECT,
  MOVE_EVENT_FS_OBJECT,
  GET_EVENT_FS_OBJECT
} from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${MULTI_SELECT_FS_OBJECT}`) {
    const indx = state.indexOf(action.payload);
    //If it's already selected, remove it (toggle behavior)
    if (indx >= 0) {
      const nextState = state.slice();
      nextState.splice(indx, 1);
      return nextState;
    }

    // if null then clear all selected items
    if (action.payload === null) {
      return [];
    }

    return state.concat(action.payload);
  }

  //Clear selected if an object is moved, or if we change folders
  if ([MOVE_EVENT_FS_OBJECT, GET_EVENT_FS_OBJECT].indexOf(action.type) >= 0) {
    return [];
  }

  return state;
};
